package entities

import kotlinx.serialization.Serializable

@Serializable
data class PlacementCat(
    val id: Int,
    val category_id: Int,
    val ad_id: Int
)